<!--公告及新闻稿-->
<template>
  <div>
    <div class="header_index_nav">
      <header>
        <div class="index_nav top">
          <div class="nav_box">
            <div class="nav_flex">
              <div class="nav_logo_w"></div>
              <div class="nav_li">
                <div class="nav_li_text">{{ $t('nav.aboutUs') }}</div>
                <div class="nav_li_text">{{ $t('nav.society') }}</div>
                <div class="nav_li_text">{{ $t('nav.news') }}</div>
                <div class="nav_li_text">{{ $t('nav.investor') }}</div>
                <div class="nav_li_text">{{ $t('nav.joinUs') }}</div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    <main class="index_main_content">
      <div class="index_main_body other">
        <div class="zcgy_img"><img src="../../assets/img/zcgy_nav.png"></div>
        <div class="zcgy_word">
          <div class="zcgy_ch">{{ $t('investor.banner.ch') }}</div>
          <div class="zcgy_en">{{ $t('investor.banner.en') }}</div>
        </div>
      </div>
      <!--二级导航-->
      <div class="second_nav">
        <div class="second_nav_list">
          <div>{{ $t('investor.tabs.report') }}</div>
          <div>{{ $t('investor.tabs.finReport') }}</div>
          <div>{{ $t('investor.tabs.court') }}</div>
          <div>{{ $t('investor.tabs.telMeeting') }}</div>
          <div>{{ $t('investor.tabs.analyst') }}</div>
          <div>{{ $t('investor.tabs.businessFile') }}</div>
          <div>{{ $t('investor.tabs.contactUs') }}</div>
          <div>{{ $t('investor.tabs.faq') }}</div>
          <div>{{ $t('investor.tabs.investorEn') }}</div>
        </div>
      </div>
      <!--内容-->
      <div class="content_width_box">
        <div class="content_title">
          <div class="title_left_h2">{{ $t('investor.report.title') }}</div>
          <div class="title_right_tab">
            <div class="tab1">{{ $t('investor.report.tabs.announcement') }}</div>
            <div class="tab2">{{ $t('investor.report.tabs.news') }}</div>
          </div>
        </div>
        <div class="select_box">
          <multiselect 
          v-model="years"
        :options="[2021,2022,2023]" 
        :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('investor.report.yearPlaceholder')"></multiselect>
        </div>
        <div class="content_list_layout">
          <div class="list_box_layout">
            <div class="year_title">2022</div>
            <div class="list_box noborder">
              <i class="iconfont icon-website-PDF"></i>
              <div class="list_content">
                <div class="list_title">公告及通告 - 內幕消息/季度業績 - 截至二零二二年九月三十日止三個月</div>
                <div class="list_date">2022-10-23</div>
              </div>
            </div>
          </div>
          <div class="list_box_layout">
            <div class="year_title">2022</div>
            <div class="list_box noborder">
              <i class="iconfont icon-website-PDF"></i>
              <div class="list_content">
                <div class="list_title">公告及通告 - 內幕消息/季度業績 - 截至二零二二年九月三十日止三個月</div>
                <div class="list_date">2022-10-23</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <footer class="index_footer">
      <div class="index_footer_layout">
        <div class="in_footer_top">
          <div class="footer_logo"><img src="../../assets/img/kslogo.png"></div>
          <div class="footer_nav">
            <div>{{ $t('nav.aboutUs') }}</div>
            <div>{{ $t('nav.society') }}</div>
            <div>{{ $t('nav.news') }}</div>
            <div>{{ $t('nav.investor') }}</div>
            <div>{{ $t('nav.joinUs') }}</div>
          </div>
          <div class="footer_follow">
            <div class="follow_title">{{ $t('footer.followUs') }}</div>
            <i class="iconfont icon-website-weixin"></i>
            <i class="iconfont icon-website-weibo"></i>
          </div>
        </div>
        <div class="in_footer_company">
          <div>金山办公</div>
          <div>西山居</div>
          <div>金山世游</div>
          <div>金山云</div>
          <div>猎豹移动</div>
        </div>
        <div class="in_footer_copyright">
          <span>{{ $t('footer.copyright') }}</span>
        </div>
        <div class="in_footer_copyright">
          <span>京公网安备11010802025727（总）</span>      
          <span>网出证（京）字第168号</span>      
          <span>京ICP备06025896-1号</span>
          <span>{{ $t('footer.privacy') }}</span>
          <span><img src="../../assets/img/kxlogo.png"></span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: null
    }
  }
}
</script>
